import createReducer from '../../../../helpers/createReducer';
import { fetchRelatedGuestsForField } from '../../../sagas/routines';
import { clearRelatedGuests } from '../../actions/related-guests';

const initialState = {
  guestsByField: {},
  fetching: false,
  fetched: false
};

const fetchHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    guestsByField: { ...state.guestsByField, ...response }
  }),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

const clearHandler = action => ({
  [action.toString()]: () => initialState
});

export default createReducer(initialState, {
  ...fetchHandler(fetchRelatedGuestsForField),
  ...clearHandler(clearRelatedGuests)
});
